import { render } from "./QueueSidebar.vue?vue&type=template&id=b9aaccfa&scoped=true"
import script from "./QueueSidebar.vue?vue&type=script&lang=js"
export * from "./QueueSidebar.vue?vue&type=script&lang=js"

import "./QueueSidebar.vue?vue&type=style&index=0&id=b9aaccfa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9aaccfa"]])

export default __exports__